<div id="resourcebody" style="width: 100%;">
    <div class="landing-body" style="overflow:visible;">
        <div *ngIf="md" style="overflow:visible;">
            <!-- sections of the landing page body -->
            <!-- identity information -->

            <a name="identity" #identity></a>
            <!-- <div style="margin-left: -10px;"> -->
            <div>
                <pdr-resource-id [record]="md" [inBrowser]="inBrowser" [theme]="theme" [collection]="collection">
                </pdr-resource-id>

                <!-- description: abstract, keywords, research areas, etc. -->
                <a name="description" #description></a>
                <pdr-resource-desc [record]="md" [inBrowser]="inBrowser" [collection]="collection"></pdr-resource-desc>
            </div>

            <!-- data access, include available files -->
            <a name="dataAccess" #dataAccess></a>
            <pdr-resource-data 
                [record]="md" 
                [inBrowser]="inBrowser" 
                [editEnabled]="editEnabled" 
                [collection]="collection"
                [theme]="theme"
                (dlStatus)="setDownloadStatus($event)">
            </pdr-resource-data>

            <!-- references -->
            <a name="references" #references></a>
            <pdr-resource-refs [record]="md" [inBrowser]="inBrowser" [collection]="collection"></pdr-resource-refs>

            <!-- About This Dataset visualization and export -->
            <a name="about" #about></a>
            <a name="references2" #references2></a>
            <pdr-resource-md [record]="md" [inBrowser]="inBrowser" [mobileMode]="mobileMode" [collection]="collection" [metricsData]="metricsData" [showJsonViewer]='showJsonViewer' [theme]="theme">
            </pdr-resource-md>
        </div>
    </div>
</div>
